















import { Component, Vue, Provide } from "vue-property-decorator";
import NewsListPage from "./NewsListPage.vue";
import Columns from "@/components/Columns.vue";
import Swiper from "@/components/Swiper.vue";
import NewsItem from "@/components/NewsItem.vue";
import request from "@/api/index";
import { ColumnsConfig } from "@/common/BaseConfig";
import { INewsItem } from "@/api/types.d";
import { List, PullRefresh } from "vant";
@Component({
  components: {
    Swiper,
    NewsItem,
    Columns,
    VanList: List,
    VanPullRefresh: PullRefresh
  }
})
export default class PartyBuilding extends NewsListPage {
  carousels: object[] = [];
  columnsList: object[] = [];
  init() {
    this.columnId = ColumnsConfig.党建;
    this.getSwipe();
    this.getColumnsList();
  }

  getSwipe() {
    request.getNews(true, this.columnId.split(".").lastChild).then(result => {
      if (result.data.carousels) {
        result.data.carousels.map(
          item => (item.imgList = item.images.split(","))
        );
        this.carousels = result.data.carousels;
        this.isLoading = false;
      }
    });
  }

  getColumnsList() {
    request.getColumns(this.columnId).then(result => {
      this.columnsList = result.data.dataList;
    });
  }
  onRefresh() {
    this.lastItem = undefined;
    this.getNewsList(true);
    this.getSwipe();
  }
}
